import { Sport } from '#src/__generated__/globalTypes.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';

import { useFeatureFlags } from './useFeatureFlags.tsx';

export const useEnableSorare27Nav = () => {
  const { sport } = useSportContext();
  const {
    flags: {
      enableSorare27Nav = {
        [Sport.BASEBALL]: false,
        [Sport.FOOTBALL]: false,
        [Sport.NBA]: false,
      },
    },
  } = useFeatureFlags();

  return !!enableSorare27Nav[sport];
};
